import { render, staticRenderFns } from "./myArticleItem.vue?vue&type=template&id=8942af6a&scoped=true&"
import script from "./myArticleItem.vue?vue&type=script&lang=js&"
export * from "./myArticleItem.vue?vue&type=script&lang=js&"
import style0 from "./myArticleItem.vue?vue&type=style&index=0&id=8942af6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8942af6a",
  null
  
)

export default component.exports